import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
	ROUTE_SPORTSBOOK,
	ROUTE_LIVEBETTING,
	ROUTE_TVBET,
	ROUTE_WE_SPIN,
	ROUTE_VIRTUALS,
	ROUTE_FREE_TO_PLAY_CUSTOM
} from '~/components/router/constants.js';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import { FilterLink } from '~/components/header/filters.js';
import { selectNavbarMenu } from '~/components/brand/ducks/selectors.js';
import useTranslations from '~/components/translation/use-translations.ts';
import useSportsbookNavigation from '~/components/sportsbook/use-sportsbook-navigation.js';
import ProductDisabledPopup from './product-disabled-popup.js';
import useShowPopup from './use-show-popup.js';
import SplashtechGlobalLinks from '~/components/splashtech/splashtech-global-links.tsx';
import { BadgeNew } from '@comeon/ui';
import { insertTrackEvent } from '@comeon/analytics/index.js';
import LinkFreeToPlay from './porduct-navbar-f2p-link';

const TEXT_KEYS = [
	'MOBILE_MAIN_MENU_SPORTS',
	'MOBILE_MAIN_MENU_LIVE_SPORTS',
	'MOBILE_MAIN_MENU_CASINO',
	'MOBILE_LIVE_CASINO_BUTTON',
	'MOBILE_MAIN_MENU_WESPIN',
	'MOBILE_HIGHLIGHT_GAMES_BUTTON',
	'PRODUCT_DISABLED_POPUP_TITLE',
	'PRODUCT_DISABLED_POPUP_DESCRIPTION',
	'PRODUCT_NAVBAR_VIRTUALS',
	'BUTTON_CUSTOMER_SUPPORT',
	'BUTTON_CANCEL',
	'MOBILE_MAIN_MENU_TVBET',
	'NEW',
	'PRODUCT_NAVBAR_FREE_TO_PLAY',
	'PRODUCT_FREE_TO_PLAY_CUSTOM_PATH'
];

const ProductNavbarBadgeNew = styled(BadgeNew)`
	position: absolute;
	right: -26px;
	top: -4px;
`;

const ProductNavbarLinks = ({ oldEnough, isSelfExcluded, onClick }) => {
	const products = useSelector(selectNavbarMenu);
	const sportsbookNavigation = useSportsbookNavigation();
	const [showPopup, doClosePopup] = useShowPopup();

	const { translations, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const { ROUTE_CASINO, ROUTE_CASINO_EXPLORE, ROUTE_LIVE_CASINO, ROUTE_LIVE_CASINO_EXPLORE } = useCasinoRoutes();

	return (
		!isLoadingTranslations && (
			<>
				{products
					.map(product => {
						switch (product) {
							case 'sportsbook':
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="sportsbook"
										href={ROUTE_SPORTSBOOK}
										activeMatch={ROUTE_SPORTSBOOK}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'sportsbook'
											});
											sportsbookNavigation.navigateToProduct('sportsbook');
										}}
									>
										{translations.MOBILE_MAIN_MENU_SPORTS}
									</FilterLink>
								);
							case 'live-betting':
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="live-betting"
										href={ROUTE_LIVEBETTING}
										activeMatch={ROUTE_LIVEBETTING}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'live-betting'
											});
											sportsbookNavigation.navigateToProduct('livebetting');
											// insertInitialMetaEvent(product);
										}}
									>
										{translations.MOBILE_MAIN_MENU_LIVE_SPORTS}
									</FilterLink>
								);
							case 'casino':
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="casino"
										activeMatch={ROUTE_CASINO}
										href={ROUTE_CASINO_EXPLORE}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'casino'
											});
											// insertInitialMetaEvent(product);
										}}
									>
										{translations.MOBILE_MAIN_MENU_CASINO}
									</FilterLink>
								);

							case 'livecasino': {
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="live-casino"
										activeMatch={ROUTE_LIVE_CASINO}
										href={ROUTE_LIVE_CASINO_EXPLORE}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'live-casino'
											});
											// insertInitialMetaEvent(product);
										}}
										retainCase
									>
										{translations.MOBILE_LIVE_CASINO_BUTTON}
									</FilterLink>
								);
							}
							case 'we-spin':
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="wespin"
										retainCase
										className="u-relative"
										href={ROUTE_WE_SPIN}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'we-spin'
											});
											// insertInitialMetaEvent(product);
										}}
									>
										{translations.MOBILE_MAIN_MENU_WESPIN}
									</FilterLink>
								);
							case 'virtuals':
								return (
									<FilterLink
										key={`navbar-${product}`}
										href={ROUTE_VIRTUALS}
										data-at={ROUTE_VIRTUALS}
										retainCase
										activeMatch={ROUTE_VIRTUALS}
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'virtuals'
											});
										}}
									>
										{translations.PRODUCT_NAVBAR_VIRTUALS}
									</FilterLink>
								);
							case 'tvbet':
								return (
									<FilterLink
										key={`navbar-${product}`}
										data-at="tvbet"
										href={ROUTE_TVBET}
										activeMatch={ROUTE_TVBET}
										retainCase
										onClick={() => {
											insertTrackEvent({
												category: 'Top Nav Item',
												action: 'Click',
												label: 'tvbet'
											});
										}}
									>
										{translations.MOBILE_MAIN_MENU_TVBET}
									</FilterLink>
								);
							case 'splash-tech':
								return (
									<SplashtechGlobalLinks
										key={`navbar-${product}`}
										product={product}
										badge={<ProductNavbarBadgeNew>{translations.NEW}</ProductNavbarBadgeNew>}
									/>
								);
							case 'free-to-play':
								return (
									<LinkFreeToPlay
										key={`navbar-${product}`}
										label={translations.PRODUCT_NAVBAR_FREE_TO_PLAY}
										route={ROUTE_FREE_TO_PLAY_CUSTOM}
										product={product}
										customF2Ppath={translations.PRODUCT_FREE_TO_PLAY_CUSTOM_PATH}
										oldEnough={oldEnough}
										isSelfExcluded={isSelfExcluded}
										onClick={onClick}
									/>
								);
							default:
								return null;
						}
					})
					.filter(Boolean)}
				{showPopup && <ProductDisabledPopup onClose={doClosePopup} />}
			</>
		)
	);
};

export default ProductNavbarLinks;
